enum submittedStatus {
    draft = 1, //ร่าง
    sent = 2, //ส่งเรื่องแล้ว
    received = 3, //รับเรื่องแล้ว
    directorAssigned = 4, //กำหนดกรรมการแล้ว
    waitSynthesis = 5, //รอสังเคราะห์ความเห็น
    proceedingCertificate = 6, //ดำเนินการทำใบรับรอง
    waitSign = 7, //รอลงนาม
    complete = 8, //ดำเนินการเสร็จสมบูรณ์
    incorrectDocument = 11, //เอกสารไม่ครบหรือไม่ถูกต้อง, รอผู้วิจัยแก้ไขเอกสาร
    resultConsideration = 13, //ดำเนินการออกผลพิจารณา
    considering = 14, //กำลังพิจารณา
    ProceedingMemoMessage = 15, //ดำเนินการทำใบบันทึกข้อความ
    waitingEditProject = 16, //รอแก้ไขโครงการ
    waitingSetCopies = 17, //รอกำหนดชุดเอกสาร
    waitingSentReviewer = 18, //รอส่งผู้ทบทวน
}
export default submittedStatus
